(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class FacetsSearchBox extends HTMLElement {
    /** @type {number | undefined} */
    #debounceId;

    connectedCallback() {
      this.input = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="q"]'));
      this.button = this.querySelector('button');
      this.section = this.closest('.shopify-section');

      const urlQuery = new URL(window.location.href).searchParams.get('q');
      if (urlQuery && this.input && !this.input.value) {
        this.input.value = urlQuery;
      }

      this.input?.addEventListener('input', this.#handleInput);
      this.input?.addEventListener('keydown', this.#handleKeyDown);
      this.button?.addEventListener('click', () => this.input?.focus());

      if (this.input?.value) this.#filter(this.input.value);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.#handleInput);
      this.input?.removeEventListener('keydown', this.#handleKeyDown);
      clearTimeout(this.#debounceId);
    }

    #handleInput = () => {
      clearTimeout(this.#debounceId);
      this.#debounceId = window.setTimeout(() => this.#filter(this.input?.value ?? ''), 120);
    };

    #handleKeyDown = (/** @type {KeyboardEvent} */ event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      clearTimeout(this.#debounceId);
      this.#filter(this.input?.value ?? '');
    };

    /** @param {string} query */
    #filter(query) {
      if (!this.section) return;

      const value = query.trim().toLowerCase();
      const items = Array.from(this.section.querySelectorAll('.product-grid__item'));
      let visibleCount = 0;

      items.forEach((item) => {
        const matches = value === '' || (item.textContent ?? '').toLowerCase().includes(value);
        item.classList.toggle('facets-search-hidden', !matches);
        if (matches) visibleCount += 1;
      });

      this.#toggleEmptyState(items, visibleCount, value);

      const url = new URL(window.location.href);
      if (value) {
        url.searchParams.set('q', query.trim());
      } else {
        url.searchParams.delete('q');
      }
      history.replaceState(history.state, '', url);
    }

    #toggleEmptyState(items, visibleCount, value) {
      if (!this.section) return;

      let emptyMessage = this.section.querySelector('[data-facets-search-empty]');

      if (visibleCount === 0 && items.length > 0 && value !== '') {
        if (!emptyMessage) {
          emptyMessage = document.createElement('p');
          emptyMessage.setAttribute('data-facets-search-empty', '');
          emptyMessage.className = 'facets__search-empty';
          items[0]?.parentElement?.insertAdjacentElement('beforebegin', emptyMessage);
        }
        emptyMessage.textContent = `No products match "${value}"`;
      } else if (emptyMessage) {
        emptyMessage.remove();
      }
    }
  }

  if (!customElements.get('facets-search-box')) {
    customElements.define('facets-search-box', FacetsSearchBox);
  }

  class PriceRangeSlider extends HTMLElement {
    /** @type {MutationObserver | undefined} */
    #observer;

    connectedCallback() {
      this.minRange = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-role="min"]'));
      this.maxRange = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-role="max"]'));
      this.trackActive = this.querySelector('.price-facet__track-active');

      this.#syncFromAttributes();

      this.#observer = new MutationObserver(() => this.#syncFromAttributes());
      this.#observer.observe(this, { attributes: true, attributeFilter: ['data-min', 'data-max'] });
      if (this.minRange) this.#observer.observe(this.minRange, { attributes: true, attributeFilter: ['value'] });
      if (this.maxRange) this.#observer.observe(this.maxRange, { attributes: true, attributeFilter: ['value'] });

      const priceFacet = this.closest('price-facet-component');
      this.minInput = /** @type {HTMLInputElement | null | undefined} */ (
        priceFacet?.querySelector('[ref="minInput"]')
      );
      this.maxInput = /** @type {HTMLInputElement | null | undefined} */ (
        priceFacet?.querySelector('[ref="maxInput"]')
      );
      if (!this.minInput || !this.maxInput) {
        const textInputs = priceFacet?.querySelectorAll('.price-facet__input') ?? [];
        this.minInput = this.minInput || textInputs[0];
        this.maxInput = this.maxInput || textInputs[1];
      }

      this.minRange?.addEventListener('input', this.#handleRangeInput);
      this.maxRange?.addEventListener('input', this.#handleRangeInput);
      this.minRange?.addEventListener('change', this.#handleRangeCommit);
      this.maxRange?.addEventListener('change', this.#handleRangeCommit);
      this.minInput?.addEventListener('change', this.#handleTextChange);
      this.maxInput?.addEventListener('change', this.#handleTextChange);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.minRange?.removeEventListener('input', this.#handleRangeInput);
      this.maxRange?.removeEventListener('input', this.#handleRangeInput);
      this.minRange?.removeEventListener('change', this.#handleRangeCommit);
      this.maxRange?.removeEventListener('change', this.#handleRangeCommit);
      this.minInput?.removeEventListener('change', this.#handleTextChange);
      this.maxInput?.removeEventListener('change', this.#handleTextChange);
    }

    #syncFromAttributes() {
      this.min = Number(this.dataset.min) || 0;
      this.max = Number(this.dataset.max) || 100;

      if (this.minRange) {
        const attrValue = this.minRange.getAttribute('value');
        if (attrValue !== null) this.minRange.value = attrValue;
      }
      if (this.maxRange) {
        const attrValue = this.maxRange.getAttribute('value');
        if (attrValue !== null) this.maxRange.value = attrValue;
      }

      this.#updateTrack();
    }

    #handleRangeInput = () => {
      if (!this.minRange || !this.maxRange) return;

      if (Number(this.minRange.value) > Number(this.maxRange.value)) {
        this.minRange.value = this.maxRange.value;
      }
      if (Number(this.maxRange.value) < Number(this.minRange.value)) {
        this.maxRange.value = this.minRange.value;
      }

      if (this.minInput) this.minInput.value = this.#toMajorUnits(this.minRange.value);
      if (this.maxInput) this.maxInput.value = this.#toMajorUnits(this.maxRange.value);

      this.#updateTrack();
    };

    #toMajorUnits(minorUnitsValue) {
      return (Number(minorUnitsValue) / 100).toFixed(2);
    }

    #toMinorUnits(majorUnitsValue) {
      return Math.round(Number(majorUnitsValue) * 100);
    }

    #handleRangeCommit = (event) => {
      const input = event.target === this.minRange ? this.minInput : this.maxInput;
      this.#dispatchChange(input);
    };

    #dispatchChange(input) {
      input?.dispatchEvent(new Event('change', { bubbles: true }));
    }

    #handleTextChange = () => {
      setTimeout(() => {
        if (this.minRange && this.minInput?.value) {
          this.minRange.value = String(this.#toMinorUnits(this.minInput.value));
        }
        if (this.maxRange && this.maxInput?.value) {
          this.maxRange.value = String(this.#toMinorUnits(this.maxInput.value));
        }
        this.#updateTrack();
      }, 0);
    };

    #updateTrack() {
      if (!this.minRange || !this.maxRange || !this.trackActive) return;

      const range = this.max - this.min || 1;
      const minPercent = ((Number(this.minRange.value) - this.min) / range) * 100;
      const maxPercent = ((Number(this.maxRange.value) - this.min) / range) * 100;

      this.trackActive.style.left = `${minPercent}%`;
      this.trackActive.style.right = `${100 - maxPercent}%`;
    }
  }

  if (!customElements.get('price-range-slider')) {
    customElements.define('price-range-slider', PriceRangeSlider);
  }

  /*
   * Duplicate-filter fix.
   * The mobile pills ([data-facets-copy="mobile"]) and the desktop accordion
   * ([data-facets-copy="desktop"]) sit inside the SAME <form>, so every filter
   * input exists twice with the same name. The hidden copy still gets
   * serialized by FormData, which sends e.g.
   *   filter.v.price.gte=&filter.v.price.gte=100
   * and Shopify ignores the price filter (and unchecking a list filter fails
   * because the hidden copy is still checked).
   * Disabled inputs are skipped by FormData, so we disable whichever copy is
   * hidden for the current viewport. Re-applied right before any interaction
   * (capture phase, so it runs before facets.js) because section re-renders
   * replace the markup and drop the disabled state.
   */
  const facetsMobileQuery = window.matchMedia('(max-width: 749px)');

  function syncFacetCopies() {
    const isMobile = facetsMobileQuery.matches;

    document.querySelectorAll('.facets__form').forEach((form) => {
      const mobileCopy = form.querySelector('[data-facets-copy="mobile"]');
      const desktopCopy = form.querySelector('[data-facets-copy="desktop"]');
      if (!mobileCopy || !desktopCopy) return;

      mobileCopy.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = !isMobile;
      });
      desktopCopy.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = isMobile;
      });
    });
  }

  syncFacetCopies();
  facetsMobileQuery.addEventListener('change', syncFacetCopies);
  ['pointerdown', 'focusin', 'keydown', 'input', 'change', 'submit'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        if (event.target instanceof Element && event.target.closest('.facets__form')) {
          syncFacetCopies();
        }
      },
      true
    );
  });

  function initPillPanels() {
  document.querySelectorAll('.pills').forEach((pillsEl) => {
    pillsEl.querySelectorAll('details').forEach((details) => {
      const trigger = details.querySelector('summary');
      const panel = details.querySelector('.facets__panel-content, .facets__quick-sublinks');
      if (!trigger || !panel || details.dataset.pillPanelBound) return;
      details.dataset.pillPanelBound = 'true';

   const position = () => {
  const rect = trigger.getBoundingClientRect();
  const margin = 10; // gap to keep from the viewport edge
  const viewportWidth = window.innerWidth;
  const panelWidth = panel.offsetWidth || 280;

  let left = rect.left;

  if (left + panelWidth > viewportWidth - margin) {
    left = viewportWidth - panelWidth - margin;
  }
  if (left < margin) {
    left = margin;
  }

  panel.style.setProperty('--pill-panel-top', `${rect.bottom}px`);
  panel.style.setProperty('--pill-panel-left', `${left}px`);
};

      const cleanup = () => {
        window.removeEventListener('scroll', position, true);
        window.removeEventListener('resize', position);
      };

      details.addEventListener('toggle', () => {
        if (details.open) {
          position();
          window.addEventListener('scroll', position, true);
          window.addEventListener('resize', position);
        } else {
          cleanup();
        }
      });
    });
  });
}

initPillPanels();
  } catch(e) { console.error(e); }
})();

})();
